export const FORM_INFO = {
  income: [
    {
      number: '1',
      name: 'employment',
      type: 'income',
      hasForm: true,
    },
    {
      number: '2',
      name: 'selfEmployment',
      type: 'income',
      hasForm: true,
    },
    {
      number: '3',
      name: 'militaryPay',
      type: 'income',
      hasForm: true,
    },
    {
      number: '4',
      name: 'notWorking',
      type: 'text',
      hasForm: true,
    },
    {
      number: '5',
      name: 'unemploymentBenefits',
      type: 'income',
      hasForm: true,
    },
    {
      number: '6',
      name: 'socialSecurity',
      type: 'income',
      hasForm: true,
    },
    {
      number: '7',
      name: 'supplementalSecurity',
      type: 'income',
      hasForm: true,
    },
    {
      number: '8',
      name: 'vaBenefits',
      type: 'income',
      hasForm: true,
    },
    {
      number: '9',
      name: 'tanf',
      type: 'income',
      hasForm: true,
    },
    {
      number: '10',
      name: 'disability',
      type: 'income',
      hasForm: true,
    },
    {
      number: '11',
      name: 'recurringGift',
      type: 'income',
      hasForm: true,
    },
    {
      number: '12',
      name: 'retirement',
      type: 'income',
      hasForm: true,
    },
    {
      number: '13',
      name: 'trust',
      type: 'income',
      hasForm: true,
    },
    {
      number: '14',
      name: 'absentFamilyMember',
      type: 'income',
      hasForm: true,
    },
    {
      number: '15',
      name: 'other',
      type: 'otherIncome',
      hasForm: true,
    },
  ],
  childSupport: [
    {
      number: '16',
      name: 'courtOrderedChildSupport',
      type: 'income',
      hasForm: false,
    },
    {
      number: '',
      name: 'receivingChildSupport',
      type: 'income',
      hasForm: true,
    },
    {
      number: '',
      name: 'collectChildSupport',
      type: 'states',
      hasForm: false,
    },
  ],
  misc: [
    {
      number: '17',
      name: 'anticipateChildSupport',
      type: 'states',
      hasForm: true,
    },
    {
      number: '18',
      name: 'publicHousing',
      type: 'text',
      hasForm: true,
    },
  ],
};

export const INCOME_VALUE_FIELDS = [
  'employmentIncome',
  'selfEmploymentIncome',
  'militaryPayIncome',
  'unemploymentBenefitsIncome',
  'socialSecurityIncome',
  'supplementalSecurityIncome',
  'vaBenefitsIncome',
  'tanfIncome',
  'disabilityIncome',
  'recurringGiftIncome',
  'retirementIncome',
  'trustIncome',
  'absentFamilyMemberIncome',
  'otherIncome',
  'receivingChildSupportIncome',
];

export const PAYRATE_VALUE_FIELDS = [
  'employmentPayRate',
  'selfEmploymentPayRate',
  'militaryPayPayRate',
  'unemploymentBenefitsPayRate',
  'socialSecurityPayRate',
  'supplementalSecurityPayRate',
  'vaBenefitsPayRate',
  'tanfPayRate',
  'disabilityPayRate',
  'recurringGiftPayRate',
  'retirementPayRate',
  'trustPayRate',
  'absentFamilyMemberPayRate',
  'otherPayRate',
  'receivingChildSupportPayRate',
];

export const HOURSWEEKSMONTHS_VALUE_FIELDS = [
  'employmentHoursWeeksMonths',
  'selfEmploymentHoursWeeksMonths',
  'militaryPayHoursWeeksMonths',
  'unemploymentBenefitsHoursWeeksMonths',
  'socialSecurityHoursWeeksMonths',
  'supplementalSecurityHoursWeeksMonths',
  'vaBenefitsHoursWeeksMonths',
  'tanfHoursWeeksMonths',
  'disabilityHoursWeeksMonths',
  'recurringGiftHoursWeeksMonths',
  'retirementHoursWeeksMonths',
  'trustHoursWeeksMonths',
  'absentFamilyMemberHoursWeeksMonths',
  'otherHoursWeeksMonths',
  'receivingChildSupportHoursWeeksMonths',
];

export const INCOME_ROW_NAMES = [
  'employment',
  'selfEmployment',
  'militaryPay',
  'notWorking',
  'unemploymentBenefits',
  'socialSecurity',
  'supplementalSecurity',
  'vaBenefits',
  'tanf',
  'disability',
  'recurringGift',
  'retirement',
  'trust',
  'other',
  'absentFamilyMember',
  'courtOrderedChildSupport',
  'receivingChildSupport',
  'collectChildSupport',
  'anticipateChildSupport',
  'publicHousing',
];

export const INITIAL_INCOME_VALUES = {
  employmentIncome: '0.00',
  selfEmploymentIncome: '0.00',
  militaryPayIncome: '0.00',
  unemploymentBenefitsIncome: '0.00',
  socialSecurityIncome: '0.00',
  supplementalSecurityIncome: '0.00',
  vaBenefitsIncome: '0.00',
  tanfIncome: '0.00',
  disabilityIncome: '0.00',
  recurringGiftIncome: '0.00',
  retirementIncome: '0.00',
  trustIncome: '0.00',
  absentFamilyMemberIncome: '0.00',
  otherIncome: '0.00',
  receivingChildSupportIncome: '0.00',
  courtOrderedChildSupportIncome: '0.00',
  hapPaymentIncome: '0.00',
  residentPaymentIncome: '0.00',
};

export const STATE_INITIAL_INCOME_VALUES = {
  anticipateChildSupportState: '',
  collectChildSupportState: '',
};

const INDEPENDENT_LIVING_FORM_INFO = {
  income: [
    {
      number: '1',
      name: 'employment',
      type: 'income',
      hasForm: true,
    },
    {
      number: '2',
      name: 'selfEmployment',
      type: 'income',
      hasForm: true,
    },
    {
      number: '3',
      name: 'militaryPay',
      type: 'income',
      hasForm: true,
    },
    {
      number: '4',
      name: 'notWorking',
      type: 'text',
      hasForm: true,
    },
    {
      number: '5',
      name: 'unemploymentBenefits',
      type: 'income',
      hasForm: true,
    },
    {
      number: '6',
      name: 'socialSecurity',
      type: 'income',
      hasForm: true,
    },
    {
      number: '7',
      name: 'pension',
      type: 'income',
      hasForm: false,
    },
    {
      number: '8',
      name: 'supplementalSecurity',
      type: 'income',
      hasForm: true,
    },
    {
      number: '9',
      name: 'vaBenefits',
      type: 'income',
      hasForm: true,
    },
    {
      number: '10',
      name: 'tanf',
      type: 'income',
      hasForm: true,
    },
    {
      number: '11',
      name: 'disability',
      type: 'income',
      hasForm: true,
    },
    {
      number: '12',
      name: 'incomeFromOnlineSources',
      type: 'income',
      hasForm: false,
    },
    {
      number: '13',
      name: 'unearnedIncome17AndUnder',
      type: 'income',
      hasForm: false,
    },
    {
      number: '14',
      name: 'recurringGift',
      type: 'income',
      hasForm: true,
    },
    {
      number: '15',
      name: 'retirement',
      type: 'income',
      hasForm: true,
    },
    {
      number: '16',
      name: 'trust',
      type: 'income',
      hasForm: true,
    },
    {
      number: '17',
      name: 'absentFamilyMember',
      type: 'income',
      hasForm: true,
    },
    {
      number: '18',
      name: 'other',
      type: 'otherIncome',
      hasForm: true,
    },
  ],
  childSupport: [
    {
      number: '19',
      name: 'courtOrderedChildSupport',
      type: 'income',
      hasForm: false,
    },
    {
      number: '',
      name: 'receivingChildSupport',
      type: 'income',
      hasForm: true,
    },
    {
      number: '',
      name: 'collectChildSupport',
      type: 'states',
      hasForm: false,
    },
  ],
  misc: [
    {
      number: '20',
      name: 'anticipateChildSupport',
      type: 'states',
      hasForm: true,
    },
    {
      number: '21',
      name: 'publicHousing',
      type: 'text',
      hasForm: true,
    },
  ],
};

const INDEPENDENT_LIVING_INCOME_VALUE_FIELDS = [
  'employmentIncome',
  'selfEmploymentIncome',
  'militaryPayIncome',
  'unemploymentBenefitsIncome',
  'socialSecurityIncome',
  'supplementalSecurityIncome',
  'pensionIncome',
  'vaBenefitsIncome',
  'tanfIncome',
  'disabilityIncome',
  'recurringGiftIncome',
  'unearnedIncome17AndUnderIncome',
  'incomeFromOnlineSourcesIncome',
  'retirementIncome',
  'trustIncome',
  'absentFamilyMemberIncome',
  'otherIncome',
  'receivingChildSupportIncome',
];

export const INDEPENDENT_LIVING_INCOME_ROW_NAMES = [
  'employment',
  'selfEmployment',
  'militaryPay',
  'notWorking',
  'unemploymentBenefits',
  'socialSecurity',
  'pension',
  'supplementalSecurity',
  'vaBenefits',
  'tanf',
  'disability',
  'incomeFromOnlineSources',
  'unearnedIncome17AndUnder',
  'recurringGift',
  'retirement',
  'trust',
  'other',
  'absentFamilyMember',
  'courtOrderedChildSupport',
  'receivingChildSupport',
  'collectChildSupport',
  'anticipateChildSupport',
  'publicHousing',
];

export const ORGANIZATION_FIELDS_MAP = {
  alternate: {
    INCOME_VALUE_FIELDS: [...INDEPENDENT_LIVING_INCOME_VALUE_FIELDS],
    FORM_INFO: { ...INDEPENDENT_LIVING_FORM_INFO },
    INCOME_ROW_NAMES: [...INDEPENDENT_LIVING_INCOME_ROW_NAMES],
  },
  default: {
    INCOME_ROW_NAMES,
    INCOME_VALUE_FIELDS,
    FORM_INFO,
  },
};
